export const AUTH_BASE = process.env.NEXT_PUBLIC_AUTH_BASE_ADDRESS;
const USER_BASE_ADDRESS = process.env.NEXT_PUBLIC_USER_BASE_ADDRESS;
const OMS_BASE = process.env.NEXT_PUBLIC_OMS_BASE_URL;
export const ZEE5_BASE_ADDRESS = process.env.PUBLIC_URL;
export const USER_API_BASE_ADDRESS =
  process.env.NEXT_PUBLIC_USER_API_BASE_ADDRESS;
const STATIC_PAGE_BASE_ADDRESS =
  process.env.NEXT_PUBLIC_STATIC_PAGE_BASE_ADDRESS;

const SUBSCRIPTION_API = process.env.NEXT_PUBLIC_SUBSCRIPTION_API;
const GWAPI_BASE_ADDRESS = process.env.NEXT_PUBLIC_GWAPI;
const DEVICE_API = process.env.DEVICE_ID;
const VID_LIKE_URL = process.env.NEXT_PUBLIC_VIDEO_LIKE_URL;
const AMA_URL = process.env.NEXT_PUBLIC_AMA_URL;
const TOP_HITS_API_BASE_ADDRESS =
  process.env.NEXT_PUBLIC_TOP_HITS_API_BASE_ADDRESS;
const CONTENT_API_BASE_ADDRESS =
  process.env.NEXT_PUBLIC_CONTENT_API_BASE_ADDRESS;
const FEATURE_URL = process.env.NEXT_PUBLIC_FEATURE_URL;
const ZEETV_API_BASE_ADDRESS = process.env.NEXT_PUBLIC_ZEETV_API_BASE_URL;
const STATIC_FOOTER_API_URL = process.env.NEXT_PUBLIC_STATIC_FOOTER_API_URL;
export const REFERRAL_BASE_ADDRESS = process.env.NEXT_PUBLIC_REFERRAL_BASE_URL;
export const RECO_API_CONSTANT = process.env.NEXT_PUBLIC_RECO_API_BASE_URL;

//display ads
export const SPAPI_ADS_URL = `${process.env.NEXT_PUBLIC_SPAPI_ADS_URL}/singlePlayback/v2/displayAds`;
export const GLOBAL_SPAPI_ADS_URL = `${process.env.NEXT_PUBLIC_SPAPI_ADS_URL}/singlePlayback/v2/displayAds`;

const PAYMENT_BASE_ADDRESS = process.env.PAYMENT_BASE_ADDRESS;
export const PAY_BASE_URL1 = `${PAYMENT_BASE_ADDRESS}/paymentGateway`;
export const SINGLE_LAUNCH_API = process.env.NEXT_PUBLIC_SINGLE_LAUNCH_API;
export const SINGLEPLAY_URL = `${process.env.NEXT_PUBLIC_SPAPI_URL}/singlePlayback/v2/getDetails/secure`;
export const B2BAPI_COUNTRY_URL =
  process.env.NEXT_PUBLIC_XTRA_ZEE5_BASE_ADDRESS;
export const FINGER_PRINT_URL = 'https://fpz.zee5.com';
export const AUTH_BASE_URL = `${AUTH_BASE}/v1/user`;
export const SETTINGS_API_URL = `${USER_BASE_ADDRESS}/v1/settings`;
export const GUEST_USER_REGISTRATION_URL = `${AUTH_BASE}/v1/user/guestUserRegistration`;
export const DISPLAY_PLANS_URL = `${OMS_BASE}/v1/plans/display`;
export const PLANS_URL = `${OMS_BASE}/v2/plans`;
export const NEW_SUBS_UI = `${OMS_BASE}/v1/pages/plans/selection`;
export const PROMOTION_API_URL_NEW = `${OMS_BASE}/v3/promotions`;
export const SUBSCRIPTION_API_URL = `${SUBSCRIPTION_API}/v1/subscription`;
export const PLAN_API_URL = `${OMS_BASE}/v1/plan/`;
export const PROMO_CODE_API_URL = `${SUBSCRIPTION_API}/v2/promotion/`;
export const UPGRADEPLAN_API_URL = `${OMS_BASE}/v1/discountedplans/upgradesubscription/`;
export const GET_USER_TOKEN = `${AUTH_BASE}/v1/user/getusertoken`;
export const SEND_OTP = `${AUTH_BASE}/v1/user/sendotp`;
export const SEND_OTP_CAPTCHA = `${AUTH_BASE}/v1/user/sendotpcaptcha`;
export const OFFER_VALIDITY_URL = `${PAY_BASE_URL1}/validateOffer`;
// verify otp
export const VERIFY_OTP = `${AUTH_BASE}/v1/user/verifyotp`;
export const REGISTER_USER_WITH_OTP = `${AUTH_BASE}/v1/user/registerWithOTPMobileorEmail`;
//data collection
export const DATA_COLLECTION = `${USER_BASE_ADDRESS}/v1/user/datacollection`;
export const SETTINGS = `${USER_BASE_ADDRESS}/v1/settings`;

// GraphQl API

export const GRAPHQL_ENDPOINT = `${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}/artemis/apq`;

//tvshow details page story rails
export const ZEETV_STORY_DETAILS_PAGE_API_URL = `${ZEE5_BASE_ADDRESS}/zee5news/wp-json/api/v1/show`;
//tvshow Consumption page story rails
export const TV_SHOW_CONSUMPTION_STORIES_API_URL = `${ZEETV_API_BASE_ADDRESS}/wp-json/api/v1/show`;

export const COUNTRY_CODE_LIST = process.env
  .NEXT_PUBLIC_COUNTRYLIST_LAUNCH_API as string;

//Cloudinary for image fetching
const CLOUDINARY_IMAGE_DOMAIN = process.env.NEXT_PUBLIC_CLOUDINARY_IMAGE_DOMAIN;
export const CLOUDINARY_IMAGE_URL = `${CLOUDINARY_IMAGE_DOMAIN}/image/upload/`;
export const CLOUDINARY_WEBP_IMAGE_URL_PARAMS =
  ',c_scale,f_webp,q_auto:eco/resources/';
export const CLOUDINARY_AVIF_IMAGE_URL_PARAMS =
  ',c_scale,f_avif,q_auto:eco/resources/';
export const CLOUDINARY_AUTO_IOS_IMAGE_URL_PARAMS = `,c_scale,f_jp2,q_auto:eco/resources/`;
export const CLOUDINARY_AUTO_IMAGE_URL_PARAMS = `,c_scale,f_auto,q_auto:eco/resources/`;
(',c_scale,f_webp,q_auto:eco/resources/');
export const CLOUDINARY_WEBP_IMAGE_URL_PARAMS_SPORTS =
  ',c_scale,f_webp,q_auto:eco/sports/';
export const CLOUDINARY_AUTO_IOS_IMAGE_URL_PARAMS_SPORTS = `,c_scale,f_jp2,q_auto:eco/sports/`;
export const CLOUDINARY_AUTO_IMAGE_URL_PARAMS_SPORTS = `,c_scale,f_auto,q_auto:eco/sports/`;

export const GOOGLE_MIC_SUPPORT_LINK =
  'https://support.google.com/chrome/?p=ui_voice_search&hl=en-US';

export const POLICIES_API = `${STATIC_PAGE_BASE_ADDRESS}`;

//share
export const ONE_LINK_API = `${process.env.NEXT_PUBLIC_CPAPI_BASE_URL}/appsflyer/v2/shorturl`;

// ILT
const SPORTS_BASE_ROUTE = 'sports';
const CRICKET_ROUTE = 'cricket/ilt20';
export const SPORTS_ROUTE = `${SPORTS_BASE_ROUTE}/${CRICKET_ROUTE}`;

export const MATCH_CLIPS = 'match-clips';

//------ Watchlist Section -------
//Add to watchlist
export const USERAPI_ADD_TO_WATCHLIST_URL = `${USER_API_BASE_ADDRESS}/v1/watchlist`;
//Get Item from watchlist
export const GWAPI_GET_WATCHLIST_URL = `${GWAPI_BASE_ADDRESS}/user/v2/watchlist`;

export const WATCH_HISTORY_BASE_ADDRESS = `${process.env.NEXT_PUBLIC_WATCH_HISTORY_BASE_ADDRESS}/api/v1/watchhistory`;

export const OFFERS_JSON_URL = `${process.env.NEXT_PUBLIC_CONFIG_JSON}?appVersion=${process.env.APP_VERSION}`;

export const REDIRECTION_JSON_URL = `${process.env.NEXT_PUBLIC_REDIRECTION_CONFIG_JSON}?appVersion=${process.env.APP_VERSION}`;

export const TRUECALLER_SDK = 'truecallersdk://truesdk/web_verify';
export const TRUECALLER_WEB_STATUS = `${AUTH_BASE}/v1/user/trueCallerWebStatus`;
export const TRUECALLER_UPDATE = `${AUTH_BASE}/v1/user/trueCallerUpdate`;
export const TRUECALLER_WEB_REGISTER = `${AUTH_BASE}/v1/user/trueCallerWebRegister`;

// PREPAID CODE VERIFICATION API
export const PREPAID_CODE_VERIFICATION_API = `${process.env.NEXT_PUBLIC_PAYMENT_BASE_ADDRESS}/paymentGateway/coupon/verification`;
export const REDEMPTION_CODE_VERIFICATION_API = `${process.env.NEXT_PUBLIC_PAYMENT_BASE_ADDRESS}/paymentGateway/coupon/redemption`;

//Auth APIs
export const TWITTER_REGISTER = `${AUTH_BASE}/v2/user/registertwitter`;
export const TWITTER_LOGIN = `${AUTH_BASE}/v2/user/logintwitter`;
export const APPLE_LOGIN_API = `${AUTH_BASE}/v1/user/appleSignIn`;
export const FACEBOOK_LOGIN_API = `${AUTH_BASE}/v2/user/loginfacebook`;
export const FACEBOOK_REGISTRATION_API = `${AUTH_BASE}/v2/user/registerfacebook`;
export const GOOGLE_LOGIN_API = `${AUTH_BASE}/v2/user/logingoogle`;
export const GOOGLE_REGISTRATION_API = `${AUTH_BASE}/v1/user/registergoogle`;

//Telco token URL
export const TELCO_TOKEN_URL = `${AUTH_BASE}/partner/getdeviceuser`;
//Consumption pages API
export const CONTENT_LITE_API_URL = `${GWAPI_BASE_ADDRESS}/contentlight/details`;

export const MANDATORY_REGISTRAION_FAILURE_EXPIRY = 1 / 48; // 30 min
export const AUTH_BASE_ADDRESS = process.env.AUTH_BASE_ADDRESS;
export const RENEW_TOKEN_URL = `${AUTH_BASE_ADDRESS}/v1/user/renew`;
export const XACCESS_TOKEN_URL =
  'https://launchapi.zee5.com/token/platform_tokens';
export const ADD_AND_REMOVE_DEVICE = `${DEVICE_API}/v1/device`;
export const GET_MOVIE_SEO_PAGE_URL = `${GWAPI_BASE_ADDRESS}/v1/movie`;
export const GET_VIDEO_LIKE_URL = `${VID_LIKE_URL}/v1.0/video/getUserActionDetails`;
export const CREATE_VIDEO_LIKE_URL = `${VID_LIKE_URL}/v1.0/video/createUserAction`;
export const USER_LIST_URL = `${AMA_URL}/ama-service/features/getFeatureList`;

export const CONTENT_API_GET_TOP_SEARCH = `${TOP_HITS_API_BASE_ADDRESS}/content/tophits`;
// export const CONTENT_API_GET_TOP_SEARCH = `${CONTENT_API_BASE_ADDRESS}/content/tophits`;
export const GWAPI_UPNEXT_URL = `${RECO_API_CONSTANT}/content/reco/upnext`;
// social account linking
export const GOOGLE_LINK_URL = `${AUTH_BASE}/v1/user/trueCallerGoogleMerge`;
export const FB_LINK_URL = `${AUTH_BASE}/v1/user/trueCallerFacebookMerge`;
export const TWITTER_LINK_URL = `${AUTH_BASE}/v1/user/trueCallerTwitterMerge`;
export const EMAIL_LINK_URL = `${AUTH_BASE}/v1/user/trueCallerEmailMerge`;
export const MOBILE_LINK_URL = `${AUTH_BASE}/v1/user/trueCallerMobileMerge`;

// USER API BASE ADDRESS FOR LOGGDIN USER
export const USER_API = `${process.env.NEXT_PUBLIC_USER_BASE_ADDRESS}/v1/user`;

/*
  This API provides aggregated user details with combined responses for user and settings.
  It is used to retrieve user and settings data after the initial login and rendering of the page.
*/
export const AGGREGATED_USER_BASE_ADDRESS = `${process.env.NEXT_PUBLIC_USER_BASE_ADDRESS}/v1/userDetails`;
export const RENTAL_PURCHASES = `${SUBSCRIPTION_API}/v1/purchase`;
export const TVOD_PURCHASE_PLAN_URL = `${process.env.NEXT_PUBLIC_PURCHASE_PLAN_URL}/v1/purchaseplan`;

// guest user login url
export const GUEST_USER_LOGIN_URL = `${AUTH_BASE_URL}/guestUserLogin`;

export const ARTICLES_NEWS_URL = 'https://www.zee5.com/articles';
export const ZEEKANNADA_NEWS_URL = 'https://www.zee5.com/zeekannada/news';
export const COMBOOFFER_PAGE = '/offers/:offerName';
export const COMBOOFFER_WIDGET_FOR_MOBILE =
  'https://stcf-prod.zee5.com/prod/pwa/images/combo-1.png';
export const COMBOOFFER_WIDGET_FOR_DESKTOP =
  'https://stcf-prod.zee5.com/prod/pwa/images/combo-2.png';
export const SUPPORT_DEVICE_LINK =
  'https://helpcenter.zee5.com/portal/en/kb/articles/what-devices-can-i-use-to-watch-zee5-26-4-2021';
export const LEARN_MORE_LINK =
  'https://helpcenter.zee5.com/portal/en/kb/articles/rent-movies-with-zee-plex';
export const ZEE_SELF_ERROR = `${process.env.NEXT_PUBLIC_STATIC_CONTENT_BASE_ADDRESS}/SelfServeError.json?app_version=${process.env.APP_VERSION}`;
export const ZEE_PLAYER_MAPPING = `${process.env.NEXT_PUBLIC_STATIC_CONTENT_BASE_ADDRESS}/pwa_platform.json?app_version=${process.env.APP_VERSION}`;

export const SUBSCRIPTION_PLAN_API = `${OMS_BASE}/v1/subscription`;

export const FEATURE_LIST_URL = `${FEATURE_URL}/user-feature/v1/getFeatureList`;

// Referral API
export const TRANSLATION_DOMAIN = `${process.env.NEXT_PUBLIC_TRANSLATION_DOMAIN}/webapp-translation/`;

export const GET_TV_SHOW_SEO_GENRE_URL = `${CONTENT_API_BASE_ADDRESS}/content/seo/tvshowGenre`;
export const GET_REFERRAL_SHARE_LINK_URL = `${REFERRAL_BASE_ADDRESS}/referral/shareLink`;

//license url link
export const LICENSE_URL_FOR_TV_SHOWS_AND_MOVIES = `${GWAPI_BASE_ADDRESS}/content/details_with_licences/`;

export const GET_ALL_GENRE_URL = `${CONTENT_API_BASE_ADDRESS}/content/seo/genres-languages`;
export const HEXT_TOKEN_URL = `${AUTH_BASE_ADDRESS}/partner/getcode`;

// SIMILAR MOVIES
export const SIMILAR_MOVIES_URL = `${GWAPI_BASE_ADDRESS}/content/genre`;

//FB conversions api
export const FB_CAPI_URL = `${process.env.NEXT_PUBLIC_FB_CAPI_URL}/v1/events/`;

export const STATIC_FOOTER_URL = `${STATIC_FOOTER_API_URL}/cs/self-help/staticpage/webfooter`;
export const SEO_API = `${process.env.NEXT_PUBLIC_SEO_URL}/cs/self-help/staticpage/dynamic`;
